import React from "react"
import styled from "styled-components"
import {TextButton} from "@irati/ui/src/Button"
import {Body, H4} from "@irati/ui/src/Typography"
import {historyContext} from "@irati/utils/history"
import {Card} from "@irati/ui/src/Layout"
import {useTheme} from "@irati/ui/src/global/useTheme"
import {RouteContext} from "@irati/utils/history/utils/context"
import Flex from "@irati/ui/src/Flex"
import FormattedMessage from "@irati/utils/lang"
import {hoverRaise} from "@irati/ui/src/global/css/animations"

export interface CardActionProps {
  title: string
  subtitle: string
  img: string
  hasPermissions?: () => boolean
  onClick: (context: RouteContext) => void
}
export const ActionContainer = styled(Flex)`
  flex-grow: 1;
  > *,
  > * > * {
    width: 100%;
  }
  ${hoverRaise}
`
const CardAction: React.FC<CardActionProps> = (props, context) => {
  const {onClick, title, subtitle, img} = props
  const theme = useTheme()
  return (
    <ActionContainer>
      <TextButton onClick={() => onClick(context)}>
        <Card small>
          <Flex gap={theme.spacing.oneAndHalf} alignItems="center">
            <img src={img} height={theme.spacing.five} alt="" />
            <Flex direction="column">
              <H4>
                <FormattedMessage id={title} />
              </H4>
              <Body small>
                <FormattedMessage id={subtitle} />
              </Body>
            </Flex>
          </Flex>
        </Card>
      </TextButton>
    </ActionContainer>
  )
}
CardAction.contextTypes = historyContext

export default CardAction
